var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Img(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 303,
    viewBox: "0 0 336 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.978 156.958C322.978 197.369 306.472 233.796 280.006 259.978C254.109 285.875 218.251 301.527 178.694 301.527C139.421 301.527 103.563 285.59 77.3815 259.978C50.9151 233.796 34.4092 197.369 34.4092 156.958C34.4092 76.9895 99.01 12.3887 178.694 12.3887C258.378 12.3887 322.978 77.274 322.978 156.958Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.456 62.1914C316.9 62.1914 322.124 56.9675 322.124 50.5235C322.124 44.0794 316.9 38.8555 310.456 38.8555C304.012 38.8555 298.788 44.0794 298.788 50.5235C298.788 56.9675 304.012 62.1914 310.456 62.1914Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.532 16.6575C331.933 16.6575 335.5 13.0899 335.5 8.68908C335.5 4.28827 331.933 0.720703 327.532 0.720703C323.131 0.720703 319.563 4.28827 319.563 8.68908C319.563 13.0899 323.131 16.6575 327.532 16.6575Z",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9625 61.9055C43.3633 61.9055 46.9309 58.3379 46.9309 53.9371C46.9309 49.5363 43.3633 45.9688 38.9625 45.9688C34.5617 45.9688 30.9941 49.5363 30.9941 53.9371C30.9941 58.3379 34.5617 61.9055 38.9625 61.9055Z",
    fill: "#E4DAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2984 215.583C23.4714 215.583 30.0968 208.958 30.0968 200.785C30.0968 192.612 23.4714 185.986 15.2984 185.986C7.12548 185.986 0.5 192.612 0.5 200.785C0.5 208.958 7.12548 215.583 15.2984 215.583Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2165_12474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.663 74.0936V231.767C307.663 238.33 302.41 243.529 295.97 243.529H58.47C52.0304 243.529 46.6924 238.245 46.6924 231.767V74.0936C46.6924 67.6162 51.9457 62.332 58.47 62.332H295.97C302.41 62.332 307.663 67.6162 307.663 74.0936Z",
    fill: "#F3F1FC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 74.0936V91.736H46.6924V74.0936C46.6924 67.6162 51.9457 62.332 58.47 62.332H295.97C302.41 62.332 307.663 67.6162 307.663 74.0936Z",
    fill: "#7647EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1306 81.4244C65.564 81.4244 67.5366 79.4401 67.5366 76.9925C67.5366 74.5448 65.564 72.5605 63.1306 72.5605C60.6972 72.5605 58.7246 74.5448 58.7246 76.9925C58.7246 79.4401 60.6972 81.4244 63.1306 81.4244Z",
    fill: "#15112D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5349 81.4244C79.9683 81.4244 81.9409 79.4401 81.9409 76.9925C81.9409 74.5448 79.9683 72.5605 77.5349 72.5605C75.1015 72.5605 73.1289 74.5448 73.1289 76.9925C73.1289 79.4401 75.1015 81.4244 77.5349 81.4244Z",
    fill: "#15112D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8542 81.4244C94.2876 81.4244 96.2602 79.4401 96.2602 76.9925C96.2602 74.5448 94.2876 72.5605 91.8542 72.5605C89.4209 72.5605 87.4482 74.5448 87.4482 76.9925C87.4482 79.4401 89.4209 81.4244 91.8542 81.4244Z",
    fill: "#15112D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.175 199.125H253.182",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.153 215.404H229.203",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.759 153.272V162.051H146.421V170.488H136.423V162.051H114.393V151.994L134.813 123.442H146.506V153.357H151.759V153.272ZM136.423 135.118L123.713 153.272H136.423V135.118Z",
    fill: "#7647EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.839 171.426C166.163 171.426 156.758 162.051 156.758 146.88C156.758 131.709 166.078 122.334 176.839 122.334C187.6 122.334 196.92 131.709 196.92 146.88C196.92 162.051 187.6 171.426 176.839 171.426ZM176.839 162.392C181.838 162.392 186.837 157.363 186.837 146.965C186.837 136.567 181.838 131.539 176.839 131.539C171.84 131.539 166.841 136.567 166.841 146.965C166.841 157.363 171.84 162.392 176.839 162.392Z",
    fill: "#7647EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.048 153.272V162.051H234.71V170.488H224.712V162.051H202.682V151.994L223.102 123.442H234.795V153.357H240.048V153.272ZM224.627 135.118L211.918 153.272H224.627V135.118Z",
    fill: "#7647EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M296.124 278.347L239.358 221.627L252.372 208.613L309.092 265.379L296.124 278.347Z",
    fill: "#858B9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.857 298.304L272.33 254.776C268.695 251.142 268.695 245.218 272.33 241.584C275.964 237.949 281.888 237.949 285.523 241.584L329.05 285.111C332.685 288.746 332.685 294.669 329.05 298.304C325.415 301.939 319.492 301.939 315.857 298.304Z",
    fill: "#858B9B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M312.761 301.087L256.758 245.085C255.457 243.783 255.457 241.674 256.758 240.328L271.073 226.013C272.374 224.712 274.483 224.712 275.83 226.013L331.832 282.016C333.134 283.317 333.134 285.426 331.832 286.772L317.518 301.087C316.171 302.389 314.062 302.389 312.761 301.087Z",
    fill: "url(#paint0_linear_2165_12474)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.099 38.8555C115.686 38.8555 67.5361 87.0052 67.5361 146.418C67.5361 205.786 115.686 253.981 175.054 253.981C234.467 253.981 282.617 205.831 282.617 146.418C282.617 87.0052 234.467 38.8555 175.099 38.8555ZM175.099 234.057C127.398 234.057 88.7615 194.792 88.7615 146.373C88.7615 97.9544 127.398 58.7346 175.099 58.7346C222.8 58.7346 261.436 97.9993 261.436 146.418C261.436 194.837 222.755 234.057 175.099 234.057Z",
    fill: "url(#paint1_linear_2165_12474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2165_12474",
    x: 24.6924,
    y: 51.332,
    width: 304.971,
    height: 225.197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2165_12474"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2165_12474",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2165_12474",
    x1: 255.747,
    y1: 263.559,
    x2: 332.822,
    y2: 263.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2165_12474",
    x1: 67.4376,
    y1: 146.442,
    x2: 282.656,
    y2: 146.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Img);
export default __webpack_public_path__ + "static/media/404Img.1d78ec4595f68e1f192b008821b2b68c.svg";
export { ForwardRef as ReactComponent };